import { Loader2 } from "lucide-react";

interface CloseCalendarDialogProps {
  open: boolean;
  closing: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function CloseCalendarDialog({
  open,
  closing,
  onConfirm,
  onClose,
}: CloseCalendarDialogProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30"
      onClick={onClose}
      onKeyDown={(e) => { if (e.key === "Escape") onClose(); }}
      tabIndex={-1}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="close-calendar-title"
        className="w-full max-w-md border border-slate-300 bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="border-b border-slate-200 bg-black px-4 py-3">
          <h2 id="close-calendar-title" className="text-base  text-white">
            Close Draft Calendar
          </h2>
        </div>

        {/* Body */}
        <div className="px-4 py-4 font-semibold text-sm text-slate-700">
          By closing the calendar, you are permanently moving the process to next fiscal year.
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 border-t border-slate-200 px-4 py-3">
          <button
            type="button"
            onClick={onClose}
            disabled={closing}
            className="border border-slate-300 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={closing}
            className="border border-black-700 bg-green-700 px-4 py-2 text-sm text-white  disabled:opacity-40 disabled:cursor-not-allowed"
          >
            {closing ? (
              <span className="flex items-center gap-1">
                <Loader2 className="h-4 w-4 animate-spin" />
                Closing&hellip;
              </span>
            ) : "Close Calendar"}
          </button>
        </div>
      </div>
    </div>
  );
}
